import React, { Component } from 'react';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './mention.css';

import * as userApi from '../../../lib/api/user';

class EditorComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isReady: false,
      error: null
    };
  }

  async componentDidMount() {
    try {
      // 동적으로 quill-mention 모듈 로드 및 등록
      const [QuillMention] = await Promise.all([
        import('quill-mention'),
        import('quill-mention/dist/quill.mention.css')
      ]);

      // Quill에 mention 모듈 등록
      Quill.register('modules/mention', QuillMention.default);
      
      this.setState({ isReady: true });
    } catch (error) {
      console.error('Failed to load mention module:', error);
      // mention 없이도 에디터 사용 가능하도록
      this.setState({ isReady: true, error: error.message });
    }
  }

  getModules = () => {
    const baseModules = {
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
          { indent: '-1' },
          { indent: '+1' },
        ],
        ['link', 'image'],
        [{ align: [] }, { color: [] }, { background: [] }],
        ['clean'],
      ],
    };

    // mention 모듈이 성공적으로 로드된 경우에만 추가
    if (this.state.isReady && !this.state.error) {
      baseModules.mention = {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ['@'],
        isolateCharacter: true,
        source: this.handleMentionSource,
      };
    }

    return baseModules;
  };

  getFormats = () => {
    const baseFormats = [
      'header',
      'bold',
      'italic',
      'underline',
      'strike',
      'blockquote',
      'list',
      'bullet',
      'indent',
      'link',
      'image',
      'align',
      'color',
      'background',
    ];

    // mention이 사용 가능한 경우에만 추가
    if (this.state.isReady && !this.state.error) {
      baseFormats.push('mention');
    }

    return baseFormats;
  };

  handleMentionSource = async (searchTerm, renderList, mentionChar) => {
    try {
      if (mentionChar === '@') {
        const res = await userApi.getUsersForMention();
        
        if (res && Array.isArray(res)) {
          let filteredValues = res;

          if (searchTerm.length > 0) {
            filteredValues = res.filter(user =>
              user.value && 
              user.value.toLowerCase().includes(searchTerm.toLowerCase())
            );
          }

          renderList(filteredValues, searchTerm);
        } else {
          renderList([], searchTerm);
        }
      }
    } catch (error) {
      console.error('Error fetching mention users:', error);
      renderList([], searchTerm);
    }
  };

  handleChange = (content, delta, source, editor) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange(editor.getHTML());
    }
  };

  render() {
    const { value } = this.props;
    const { isReady, error } = this.state;

    if (!isReady) {
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <div>에디터를 로딩 중입니다...</div>
        </div>
      );
    }

    return (
      <div>
        {error && (
          <div style={{ 
            padding: '8px', 
            marginBottom: '10px', 
            backgroundColor: '#fff3cd', 
            border: '1px solid #ffeaa7',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#856404'
          }}>
            ⚠️ 멘션 기능을 사용할 수 없습니다. 기본 에디터로 사용됩니다.
          </div>
        )}
        
        <ReactQuill
          theme="snow"
          modules={this.getModules()}
          formats={this.getFormats()}
          value={value || ''}
          onChange={this.handleChange}
          placeholder="내용을 입력하세요..."
        />
      </div>
    );
  }
}

export default EditorComponent;